import { LiveData, OnEvent, Service } from '@toeverything/infra';

import { DocCreated } from '../../../doc/events';
import type { DocCreateOptions } from '../../../doc/types';
import { WorkbenchLocationChanged } from '../../../workbench/services/workbench';

export function isUserCreatedDocument(options: DocCreateOptions): boolean {
  return (
    options.createInWorkspaceRoot === true ||
    typeof options.targetFolderId === 'string'
  );
}

export function locationContainsDocId(
  location: string,
  docId: string
): boolean {
  return location
    .split(/[/?#]/)
    .filter(Boolean)
    .some(segment => {
      try {
        return decodeURIComponent(segment) === docId;
      } catch {
        return segment === docId;
      }
    });
}

@OnEvent(DocCreated, service => service.onDocCreated)
@OnEvent(WorkbenchLocationChanged, service => service.onNavigation)
export class FirstCreatedDocTelemetryPromptService extends Service {
  readonly requested$ = new LiveData(false);

  private readonly pendingDocIds = new Set<string>();

  onDocCreated(event: {
    doc: { id: string };
    docCreateOptions: DocCreateOptions;
  }) {
    if (!isUserCreatedDocument(event.docCreateOptions)) return;
    this.pendingDocIds.add(event.doc.id);
  }

  onNavigation(location: string) {
    if (this.requested$.value) return;
    const enteredCreatedDoc = [...this.pendingDocIds].some(docId =>
      locationContainsDocId(location, docId)
    );
    if (!enteredCreatedDoc) return;

    this.pendingDocIds.clear();
    this.requested$.next(true);
  }

  dismiss() {
    this.pendingDocIds.clear();
    this.requested$.next(false);
  }
}
